export default __webpack_public_path__ + "static/media/happy-girl.d4df6720.png";